module.exports = __webpack_public_path__ + "media/MRI6B.9e50e21f.mp3";